import React from 'react';
import { GetStarted } from 'src/components/app/GetStarted';
import withMarketingLayout from 'src/components/layout/MarketingLayout';

function Start(): JSX.Element {
  return <GetStarted />;
}

export default withMarketingLayout(Start);
